import { render } from "./Support.vue?vue&type=template&id=2bbc3fa5"
const script = {}

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__